import { IConfigData } from '@df/catalog/config/config.interfaces';
import { NICmsContentField } from '@icms/core/content';
import { ICmsContentService } from '@icms/core/content/icms-content.service';

export namespace ICmsEditorConfig {
    /**
     * Config model id
     */
    export const configId = 'icms.editor';

    /**
     * Config model data
     */
    export interface IModelData extends IConfigData<ICmsEditorConfig.IConfigContent> {}
    export interface IConfigContent {
        /**
         * If off click closes trays
         */
        offClickTrayClose?: boolean;
    }
}

ICmsContentService.registerConfig({
    id: ICmsEditorConfig.configId,
    name: 'iCMS Editor Config',
    fields: [
        <NICmsContentField.IToggleField>{
            key: 'offClickTrayClose',
            type: NICmsContentField.EFieldType.toggle,
            title: 'Hide iCMS trays on off-click'
        }
    ]
});
